import { useId } from "react";

import { cn } from "@/lib/utils";

export function AlphaIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-[13px] w-[11px] text-sky-blue", className)}
      viewBox="0 0 11 13"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.4 12.757c.287 0 .514-.066.68-.199.166-.127.293-.343.382-.647l.805-2.3h4.424l.814 2.3c.088.304.216.52.382.647.166.133.39.2.672.2.304 0 .548-.086.73-.258.183-.166.274-.39.274-.672 0-.2-.038-.41-.116-.631L7.061 2c-.133-.371-.327-.645-.582-.822-.254-.183-.583-.274-.987-.274-.758 0-1.268.362-1.528 1.087l-3.42 9.264a1.88 1.88 0 00-.107.59c0 .281.085.503.257.663.171.166.407.25.705.25zm2.349-4.715l1.718-5.021h.05l1.718 5.021H3.749z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CommunityScoreIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-4.5 w-[17px]", className)}
      viewBox="0 0 17 18"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M8.052 1.453c0-.573-.483-1.035-1.047-.934C3.024 1.23 0 4.731 0 8.944c0 .541.05 1.07.146 1.585.106.57.721.857 1.26.64l.668-.269c.475-.191.72-.71.656-1.218a5.95 5.95 0 01-.046-.738A5.849 5.849 0 017.138 3.25c.508-.123.914-.548.914-1.071v-.727z"
        fill="#41c9fa"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M8.905 2.152c-.008.532.406.969.924 1.09a5.849 5.849 0 014.487 5.702c0 3.233-2.604 5.854-5.816 5.854a5.797 5.797 0 01-4.735-2.455c-.305-.429-.856-.647-1.343-.446l-.658.27c-.526.218-.77.834-.469 1.318C2.798 15.897 5.463 17.5 8.501 17.5c4.694 0 8.5-3.83 8.5-8.556C17 4.72 13.96 1.21 9.96.514c-.557-.098-1.036.354-1.044.92l-.012.718z"
        fill={`url(#${id})`}
        fillRule="evenodd"
      />
      <defs>
        <radialGradient
          cx="0"
          cy="0"
          gradientTransform="matrix(.04763 8.54885 -8.30497 .04627 9.035 8.951)"
          gradientUnits="userSpaceOnUse"
          id={id}
          r="1"
        >
          <stop offset="0.179" stopColor="#ffc850" />
          <stop offset="0.503" stopColor="#ff5c00" />
        </radialGradient>
      </defs>
    </svg>
  );
}

export function DateIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-4 w-[17px] text-apple-green", className)}
      viewBox="0 0 17 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.772 15.79h11.456c.912 0 1.602-.234 2.07-.702.468-.462.702-1.144.702-2.044V2.964c0-.9-.234-1.584-.702-2.052-.468-.468-1.158-.701-2.07-.701H2.772c-.906 0-1.597.233-2.07.701C.234 1.374 0 2.058 0 2.965v10.079c0 .906.234 1.59.702 2.053.473.462 1.163.693 2.07.693zm.026-1.746c-.339 0-.596-.088-.772-.263-.175-.176-.263-.442-.263-.799V5.395c0-.357.088-.62.263-.79.176-.175.433-.263.772-.263h11.395c.34 0 .6.088.78.263.182.17.273.433.273.79v7.587c0 .357-.091.623-.272.799-.182.175-.442.263-.781.263H2.798zm4.114-6.877h.483c.152 0 .257-.027.316-.08.058-.052.087-.154.087-.306v-.483c0-.152-.029-.254-.087-.307-.059-.052-.164-.079-.316-.079h-.483c-.146 0-.251.027-.316.08-.058.052-.087.154-.087.306v.483c0 .152.029.254.087.307.065.052.17.079.316.079zm2.693 0h.492c.152 0 .257-.027.315-.08.059-.052.088-.154.088-.306v-.483c0-.152-.03-.254-.088-.307-.058-.052-.164-.079-.316-.079h-.49c-.153 0-.258.027-.317.08-.052.052-.078.154-.078.306v.483c0 .152.026.254.078.307.059.052.164.079.316.079zm2.693 0h.492c.152 0 .257-.027.315-.08.059-.052.088-.154.088-.306v-.483c0-.152-.03-.254-.088-.307-.058-.052-.164-.079-.316-.079h-.49c-.153 0-.258.027-.316.08-.053.052-.08.154-.08.306v.483c0 .152.027.254.08.307.058.052.163.079.315.079zM4.22 9.825h.483c.152 0 .257-.027.316-.08.058-.058.087-.16.087-.306v-.492c0-.152-.029-.254-.087-.307-.059-.052-.164-.079-.316-.079H4.22c-.152 0-.257.027-.315.08-.059.052-.088.154-.088.306v.492c0 .146.029.248.088.307.058.052.163.079.315.079zm2.693 0h.483c.152 0 .257-.027.316-.08.058-.058.087-.16.087-.306v-.492c0-.152-.029-.254-.087-.307-.059-.052-.164-.079-.316-.079h-.483c-.146 0-.251.027-.316.08-.058.052-.087.154-.087.306v.492c0 .146.029.248.087.307.065.052.17.079.316.079zm2.693 0h.492c.152 0 .257-.027.315-.08.059-.058.088-.16.088-.306v-.492c0-.152-.03-.254-.088-.307-.058-.052-.164-.079-.316-.079h-.49c-.153 0-.258.027-.317.08-.052.052-.078.154-.078.306v.492c0 .146.026.248.078.307.059.052.164.079.316.079zm2.693 0h.492c.152 0 .257-.027.315-.08.059-.058.088-.16.088-.306v-.492c0-.152-.03-.254-.088-.307-.058-.052-.164-.079-.316-.079h-.49c-.153 0-.258.027-.316.08-.053.052-.08.154-.08.306v.492c0 .146.027.248.08.307.058.052.163.079.315.079zM4.22 12.474h.483c.152 0 .257-.027.316-.08.058-.058.087-.16.087-.306v-.483c0-.152-.029-.254-.087-.307-.059-.058-.164-.088-.316-.088H4.22c-.152 0-.257.03-.315.088-.059.053-.088.155-.088.307v.483c0 .146.029.248.088.307.058.052.163.079.315.079zm2.693 0h.483c.152 0 .257-.027.316-.08.058-.058.087-.16.087-.306v-.483c0-.152-.029-.254-.087-.307-.059-.058-.164-.088-.316-.088h-.483c-.146 0-.251.03-.316.088-.058.053-.087.155-.087.307v.483c0 .146.029.248.087.307.065.052.17.079.316.079zm2.693 0h.492c.152 0 .257-.027.315-.08.059-.058.088-.16.088-.306v-.483c0-.152-.03-.254-.088-.307-.058-.058-.164-.088-.316-.088h-.49c-.153 0-.258.03-.317.088-.052.053-.078.155-.078.307v.483c0 .146.026.248.078.307.059.052.164.079.316.079z"
        fill="currentColor"
      />
    </svg>
  );
}

export function DownIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-1.6 w-2.5 text-white", className)}
      fill="none"
      viewBox="0 0 10 6"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 1l4 4 4-4"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}

export function MyRatingIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-4.5", className)}
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M4.4 8.398v6.77a.682.682 0 01-.677.676H.678A.68.68 0 010 15.168v-6.77c0-.371.307-.678.678-.678h3.045c.37 0 .678.307.678.678z"
        fill="#faa042"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M14.894 6.366h-2.93c.243-.975.899-1.346.899-2.707 0-2.485-2.83-4.603-3.544-.783-.213 1.028-2.554 4.751-3.595 4.833-.35.033-.645.327-.645.678v6.78c0 .372.317.666.676.676.37.013 1.005.233 1.67.466 1.144.391 2.572.89 4.084.89 1.963 0 4.184.365 3.964-2.406 1.031-.344 1.83-1.905 1.031-3.095 1.032-1.031.847-2.057 0-3.094 0 0 .688-1.72-1.61-2.238z"
        fill="#ffc850"
        fillRule="evenodd"
      />
    </svg>
  );
}

export function SelectedIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("size-5", className)}
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect fill={`url(#${id}a)`} height="8" rx="4" width="8" x="6" y="6" />
      <rect
        height="18"
        rx="9"
        stroke={`url(#${id}b)`}
        strokeWidth="2"
        width="18"
        x="1"
        y="1"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}a`}
          x1="9.988"
          x2="9.988"
          y1="6"
          y2="14"
        >
          <stop stopColor="#eb297b" />
          <stop offset="1" stopColor="#9b3699" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}b`}
          x1="9.971"
          x2="9.971"
          y1="0"
          y2="20"
        >
          <stop stopColor="#eb297b" />
          <stop offset="1" stopColor="#9b3699" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function UserRatingIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-4 w-[17px]", className)}
      viewBox="0 0 17 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.5 15.91c.333 0 .84-.31 1.33-.642C14.11 12.424 17 9.002 17 5.58 17 2.26 14.663.09 12.001.09c-1.663 0-2.82.911-3.501 2.194C7.827 1.01 6.662.09 4.999.09 2.337.09 0 2.26 0 5.58c0 3.422 2.891 6.844 7.17 9.688.49.333.997.642 1.33.642z"
        fill={`url(#${id})`}
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={id}
          x1="14.814"
          x2="3.268"
          y1="2.576"
          y2="14.254"
        >
          <stop stopColor="#f74746" />
          <stop offset="1" stopColor="#fc994c" />
        </linearGradient>
      </defs>
    </svg>
  );
}
